import { get, IResponse, post } from "@Lib/request";
import { path } from "./url";
import { ESenceType } from "@Types/constants";

const { usedCarApiV4, usedCarApiV3, newCarApiV2, newCarApiV3, newCarApiV1 } = path;

export function loginSync() {
  return get(`${usedCarApiV3}/user/syncLogin`);
}

export function requestCode(data: { account: string; type: number }) {
  return post(`${newCarApiV2}/u/verificationCode`, data);
}

export function login(data: {
  mobile: string;
  code: string;
  token?: string;
  from?: string;
  agree: number;
  origin?: number;
  device_id?: string;
  firebase?: string;
  jpush?: string;
}) {
  return post(`${newCarApiV2}/u/codeLogin`, { ...data, sessionReset: 1 });
}

export async function validLogin() {
  return get(`${newCarApiV3}/login/failCount`);
}

export async function loginWithPwd(data) {
  return post(`${newCarApiV1}/u/login`, data);
}

// 檢查是否登錄
export async function chkLogin(params?: any) {
  return await get(`${newCarApiV1}/u/chkLogin`, params);
}

/** 新版本发送验证码 */
export async function verificationCode_v3(params: { type?: ESenceType; account?: string }): Promise<IResponse<any>> {
  return await post(`${newCarApiV3}/u/verificationCode`, params);
}
